import { store } from "../index";

export function getMessageFromState(id) {
  const { intl } = store.getState();
  return intl.messages[id] || id;
}
